import { HttpParams } from '@angular/common/http';

export type FiltreTickets =
  | 'nouveaux_messages'
  | 'nouveaux_bons_intervention'
  | 'curatives_non_planifiees'
  | 'curatives_planifiees'
  | 'curatives_planifiees_depassees'
  | 'preventives_planifiees'
  | 'defauts_communication'
  | 'arret_production_centrale'
  | 'perte_production_centrale'
  | 'arret_production_onduleurs'
  | 'perte_production_onduleurs'
  | 'autres';

export type TriTickets = 'date' | 'libelle';

export type OptionsTickets = {
  filtres: readonly FiltreTickets[];
  tri: TriTickets;
};

/** Paramètres communs aux listes parc et installation ; tri stable assuré par le serveur. */
export function appliquerOptionsTickets(params: HttpParams, options?: OptionsTickets): HttpParams {
  if (!options) return params;
  if (options.filtres.length) params = params.set('filtres', options.filtres.join(','));
  return params
    .set('sort', options.tri === 'date' ? 'date_ouverture' : 'libelle')
    .set('order', options.tri === 'date' ? 'desc' : 'asc');
}
